export default {"src":"/_next/static/image/public/images/ic_enjoy_flash.9fefcafafca599263b6cc5526be6b1cb.svg","height":20,"width":21};